import { WorkstationEfficiencyModel } from "./workstation-efficiency.model";

export class LineEfficiencyModel {
    lineId: string;
    lineDesc: string;
    efficiency: number; // last op
    workstationWiseEfficiency: WorkstationEfficiencyModel[];

    constructor(lineId: string,
        lineDesc: string,
        efficiency: number,  workstationWiseEfficiency: WorkstationEfficiencyModel[]) {
            this.lineId = lineId;
            this.lineDesc = lineDesc;
            this.efficiency = efficiency;
            this.workstationWiseEfficiency = workstationWiseEfficiency;
    }
}